<template>
  <v-container>
    <!-- Title -->
    <v-row class="align-center mb-4">
      <h2 class="text-accent mb-3">
        {{ title }}
      </h2>
      <slot name="out-side-control" />
    </v-row>

    <!-- Info -->
    <div
      v-if="info"
      class="text-grey-darken-1 mb-2"
      :class="{'ml-6': $vuetify.display.smAndUp}"
    >
      <div class="mx-3">
        {{ info }}
      </div>
    </div>

    <!-- Card -->
    <v-card
      flat
      class="card-style"
      :class="{'ml-6': $vuetify.display.smAndUp}"
    >
      <v-card-title
        v-if="$slots.control"
        class="pt-2 pb-0 px-2"
      >
        <v-spacer />
        <slot name="control" />
      </v-card-title>

      <v-card-text
        v-if="$slots.default"
        :class="{'px-4 pt-3 pb-3': !noPadding, 'pa-0': noPadding}"
      >
        <slot />
      </v-card-text>

      <slot name="padding-zero" />

      <template v-if="$slots.actions">
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <slot name="actions" />
        </v-card-actions>
      </template>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: ''
      },
      info: {
        type: String,
        default: ''
      },
      noPadding: Boolean
    },
    data: () => ({}),
    methods: {}
  }
</script>
